import React, { useState, useEffect, createContext, useContext } from 'react'

import useWineriesApi from 'firebaseKit/wineries'
import { useVenueContext } from './VenueProvider'
import * as _ from 'lodash'

const WineryContext = createContext()

const WineryProvider = ({ children }) => {
  const { currentVenue, defaultVenue, isDefaultVenue } = useVenueContext()

  const { getWineries } = useWineriesApi()
  const [wineries, setWineries] = useState(null)

  const setFullyScoredWinery = (wineryName) => {
    wineries.map(winery => {
      if (winery.name === wineryName) {
        winery.fullyScored = true
      }
      return winery
    })
  }

  useEffect(() => {
    let ignore = false
    const getWineryList = async () => {
      const res = _.sortBy(
        (await getWineries())
          .filter((v) =>
            isDefaultVenue
              ? (!v.venue_id || v.venue_id === defaultVenue)
              : v.venue_id === currentVenue),
        'index'
      )
      if (ignore) {
        return
      }
      setWineries(res)
    }
    getWineryList()
    return () => {
      ignore = true
      setWineries(null)
    }
  }, [currentVenue, isDefaultVenue])

  const setWineryPreferences = (winery, scoringPreference) => {
    const prePreferencesArr = JSON.parse(localStorage.getItem('scoringPreference'))
    const preference = JSON.stringify({
      ...prePreferencesArr,
      [winery]: {
        scoringPreference
      }
    })
    localStorage.setItem('scoringPreference', preference)
  }
  const getWineryPreference = (winery) => {
    const wineriesObj = JSON.parse(localStorage.getItem('scoringPreference'))
    for (const key in wineriesObj) {
      if (key === winery) {
        return wineriesObj[key]
      }
    }
    return null
  }

  const value = {
    wineries,
    setWineries,
    setFullyScoredWinery,

    setWineryPreferences,
    getWineryPreference
  }

  return (
    <WineryContext.Provider value={value}>{children}</WineryContext.Provider>
  )
}

export default WineryProvider

export const useWineryContext = () => {
  return useContext(WineryContext)
}
